'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
const THEME_COLOR_SELECTOR = 'meta[name="theme-color"]';

// Syncs Safari browser chrome with the current Lead Magnet stage.
const useThemeColor = color => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== color) {
    t0 = () => {
      if (!color) {
        return;
      }
      const meta = document.querySelector(THEME_COLOR_SELECTOR);
      if (!meta) {
        return;
      }
      const previous = meta.content;
      meta.content = color;
      return () => {
        meta.content = previous;
      };
    };
    t1 = [color];
    $[0] = color;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};
export default useThemeColor;